import { render } from "./preview-quotation.vue?vue&type=template&id=bf305612&scoped=true"
import script from "./preview-quotation.vue?vue&type=script&lang=js"
export * from "./preview-quotation.vue?vue&type=script&lang=js"

import "./preview-quotation.vue?vue&type=style&index=0&id=bf305612&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf305612"]])

export default __exports__